export default function usePageLayout() {
  const params = useParams()

  const isHeaderEnabled = computed(() => {
    return !params.iframe || ['header', 'full'].includes(params.iframe.layout)
  })

  const isFooterEnabled = computed(() => {
    return !params.iframe || ['footer', 'full'].includes(params.iframe.layout)
  })

  return { isHeaderEnabled, isFooterEnabled }
}
